export default __webpack_public_path__ + "static/media/kg.d056ead3.svg";